import { NextPageContext } from "next";
import { getSession } from "next-auth/client";
import isLoggedIn from "src/utils/isLoggedIn";
import { authRedirect } from "src/modules/page/utils";
import { RegisterView } from "src/organisms/RegisterView";
import LoginPages from "src/Layouts/LoginPages";

const RegisterPage = (): JSX.Element => <RegisterView />;

RegisterPage.getInitialProps = async (ctx: NextPageContext) => {
  if (ctx.req && ctx.res) {
    const session = await getSession({ req: ctx.req });
    if (isLoggedIn(session)) {
      authRedirect(ctx, session);
    }
  }
  return {};
};
RegisterPage.Layout = LoginPages;
export default RegisterPage;
